// PROGRESS BAR SCRIPT
// Copied from the previous theme - requires progressbar.min.js
// 
function loadProgressBar(selector, backgroundColor, progressColor, textColor, progress, currentValue) {   
  console.log(progress, currentValue)
  
  var startDate = 1562158093580; // 03-07-2019 14:48
  var now = (new Date).getTime();
  //console.log((new Date).getTime());
  var diffMinutes = (now - startDate) * 0.001 / 60; // miliseconds to minutes
  var newMeals = parseInt(diffMinutes * 1.5, 10);
  var totalMeals = 2115548 + newMeals; // 2.115.548 was the "static" baseline score on 03-07-2019.

  var bar = new ProgressBar.Line(selector, {
    strokeWidth: 1,
    easing: 'easeInOut',
    duration: 1500,
    color: progressColor || '#C1B8AE',
    trailColor: backgroundColor || '#fff',
    trailWidth: 1,
    svgStyle: {width: '100%', height: '100%'},
    text: {
      style: {
        // Text color.
        // Default: same as stroke color (options.color)
        fontSize: '5rem',
        margin: '25px 0 0 0',
        color: textColor || 'white'
      },
      autoStyleContainer: false
    },
    from: {color: backgroundColor || '#FFEA82'},
    to: {color: progressColor || '#ED6A5A'},
    step: (state, bar) => {
      var numericValue = currentValue ? currentValue : Math.round(bar.value() * totalMeals * 2)
      var formattedValue = numericValue.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
      bar.setText(formattedValue);
    }
  });

  bar.animate(progress ? progress / 100 : 0.5);  // Number from 0.0 to 1.0
};

// $('#progress').on('inview', function (event, visible) {
//   if (visible == true) {
//     // element is now visible in the viewport
//     loadProgressBar();
//   } else {
//     // element has gone out of viewport
//   }
// });

function respondToVisibility(element, callback) {
  var options = {
    root: document.documentElement
  }

  var observer = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
      callback(entry.intersectionRatio > 0);
    });
  }, options);

  if (element) observer.observe(element);
}

respondToVisibility(document.getElementById("progress"), visible => {
  if (visible) {
    // element is now visible in the viewport
    loadProgressBar("#progress");
  } else {
    // element has gone out of viewport
  }
});
respondToVisibility(document.getElementById("one_progress1"), visible => {
  var progressBar = document.getElementById("one_progress1")
  var color = progressBar.getAttribute('data-color')
  var background = progressBar.getAttribute('data-background')
  var label = progressBar.getAttribute('data-label')
  var progress = progressBar.getAttribute('data-position')
  var currentValue = progressBar.getAttribute('data-value')
  
  if (visible) { loadProgressBar("#one_progress1", background, color, label, progress, currentValue); }
});

respondToVisibility(document.getElementById("progress1"), visible => {
  var progressBar = document.getElementById("progress1")
  var color = progressBar.getAttribute('data-color')
  var background = progressBar.getAttribute('data-background')
  var label = progressBar.getAttribute('data-label')
  var progress = progressBar.getAttribute('data-position')
  var currentValue = progressBar.getAttribute('data-value')
  
  if (visible) { loadProgressBar("#progress1", background, color, label, progress, currentValue); }
});

respondToVisibility(document.getElementById("progress2"), visible => {
  var progressBar = document.getElementById("progress2")
  var color = progressBar.getAttribute('data-color')
  var background = progressBar.getAttribute('data-background')
  var label = progressBar.getAttribute('data-label')
  var progress = progressBar.getAttribute('data-position')
  var currentValue = progressBar.getAttribute('data-value')
  
  if (visible) { loadProgressBar("#progress2", background, color, label, progress, currentValue); }
});

respondToVisibility(document.getElementById("progress3"), visible => {
  var progressBar = document.getElementById("progress3")
  var color = progressBar.getAttribute('data-color')
  var background = progressBar.getAttribute('data-background')
  var label = progressBar.getAttribute('data-label')
  var progress = progressBar.getAttribute('data-position')
  var currentValue = progressBar.getAttribute('data-value')
  
  if (visible) { loadProgressBar("#progress3", background, color, label, progress, currentValue); }
});

respondToVisibility(document.getElementById("two-progress1"), visible => {
  var progressBar = document.getElementById("two-progress1")
  var color = progressBar.getAttribute('data-color')
  var background = progressBar.getAttribute('data-background')
  var label = progressBar.getAttribute('data-label')
  var progress = progressBar.getAttribute('data-position')
  var currentValue = progressBar.getAttribute('data-value')
  
  if (visible) { loadProgressBar("#two-progress1", background, color, label, progress, currentValue); }
});


respondToVisibility(document.getElementById("two-progress2"), visible => {
  var progressBar = document.getElementById("two-progress2")
  var color = progressBar.getAttribute('data-color')
  var background = progressBar.getAttribute('data-background')
  var label = progressBar.getAttribute('data-label')
  var progress = progressBar.getAttribute('data-position')
  var currentValue = progressBar.getAttribute('data-value')
  
  if (visible) { loadProgressBar("#two-progress2", background, color, label, progress, currentValue); }
});

respondToVisibility(document.getElementById("four-progress1"), visible => {
  var progressBar = document.getElementById("four-progress1")
  var color = progressBar.getAttribute('data-color')
  var background = progressBar.getAttribute('data-background')
  var label = progressBar.getAttribute('data-label')
  var progress = progressBar.getAttribute('data-position')
  var currentValue = progressBar.getAttribute('data-value')
  
  if (visible) { loadProgressBar("#four-progress1", background, color, label, progress, currentValue); }
});
respondToVisibility(document.getElementById("four-progress2"), visible => {
  var progressBar = document.getElementById("four-progress2")
  var color = progressBar.getAttribute('data-color')
  var background = progressBar.getAttribute('data-background')
  var label = progressBar.getAttribute('data-label')
  var progress = progressBar.getAttribute('data-position')
  var currentValue = progressBar.getAttribute('data-value')
  
  if (visible) { loadProgressBar("#four-progress2", background, color, label, progress, currentValue); }
});
respondToVisibility(document.getElementById("four-progress3"), visible => {
  var progressBar = document.getElementById("four-progress3")
  var color = progressBar.getAttribute('data-color')
  var background = progressBar.getAttribute('data-background')
  var label = progressBar.getAttribute('data-label')
  var progress = progressBar.getAttribute('data-position')
  var currentValue = progressBar.getAttribute('data-value')
  
  if (visible) { loadProgressBar("#four-progress3", background, color, label, progress, currentValue); }
});
respondToVisibility(document.getElementById("four-progress4"), visible => {
  var progressBar = document.getElementById("four-progress4")
  var color = progressBar.getAttribute('data-color')
  var background = progressBar.getAttribute('data-background')
  var label = progressBar.getAttribute('data-label')
  var progress = progressBar.getAttribute('data-position')
  var currentValue = progressBar.getAttribute('data-value')
  
  if (visible) { loadProgressBar("#four-progress4", background, color, label, progress, currentValue); }
});
respondToVisibility(document.getElementById("custom-two-progress1"), visible => {
  var progressBar = document.getElementById("custom-two-progress1")
  var color = progressBar.getAttribute('data-color')
  var background = progressBar.getAttribute('data-background')
  var label = progressBar.getAttribute('data-label')
  var progress = progressBar.getAttribute('data-position')
  var currentValue = progressBar.getAttribute('data-value')
  
  if (visible) { loadProgressBar("#custom-two-progress1", background, color, label, progress, currentValue); }
});
respondToVisibility(document.getElementById("custom-two-progress2"), visible => {
  var progressBar = document.getElementById("custom-two-progress2")
  var color = progressBar.getAttribute('data-color')
  var background = progressBar.getAttribute('data-background')
  var label = progressBar.getAttribute('data-label')
  var progress = progressBar.getAttribute('data-position')
  var currentValue = progressBar.getAttribute('data-value')
  
  if (visible) { loadProgressBar("#custom-two-progress2", background, color, label, progress, currentValue); }
});

var coll = document.getElementsByClassName("collapsible");
var i;

for (i = 0; i < coll.length; i++) {
  coll[i].addEventListener("click", function() {
    this.classList.toggle("active");
    var content = this.nextElementSibling;
    if (content.style.display === "block") {
      content.style.display = "none";
    } else {
      content.style.display = "block";
    }
  });
}

